import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ icon, className, position, onClick, disabled, style, title }) => {
  return (
    icon && (
      <span
        onClick={onClick}
        className={`icon icon-${icon} icon--position--${position ? position : 'left'} ${className ? className : ''}`}
        style={{ cursor: disabled && onClick ? 'not-allowed' : onClick ? 'pointer' : undefined, ...(style ?? {}) }}
        title={title}
      />
    )
  );
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default Icon;
